var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7608_22888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 0C5.15891 0 0 4.9345 0 10.9999C0 17.0654 5.15891 22 11.4999 22C17.841 22 22.9999 17.0654 22.9999 10.9999C22.9999 4.9345 17.8411 0 11.4999 0ZM18.1034 9.14196L10.8786 16.0527C10.5714 16.3465 10.163 16.5082 9.72862 16.5082C9.29422 16.5082 8.88586 16.3465 8.57866 16.0527L4.89647 12.5306C4.58927 12.2367 4.42007 11.8461 4.42007 11.4306C4.42007 11.015 4.58927 10.6244 4.89647 10.3305C5.20355 10.0367 5.61191 9.87485 6.04643 9.87485C6.48083 9.87485 6.88931 10.0367 7.19639 10.3306L9.7285 12.7526L15.8033 6.94193C16.1105 6.64808 16.5188 6.48635 16.9532 6.48635C17.3876 6.48635 17.796 6.64808 18.1032 6.94193C18.7375 7.54867 18.7375 8.53545 18.1034 9.14196Z",
    fill: "#7EDE86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7608_22888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.bd03eb9fa775b92df0da5dab6225af9f.svg";
export { ForwardRef as ReactComponent };